import { useRef, useState, useEffect } from "react";
import { Card, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { PageTitleConstants, RoutePathConstants } from "../../Constants";
import { PageHeader, MonthlyCalendar } from "wup-module1-base";
import moment from "moment";

function Calendar() {
  const navigate = useNavigate();
  const calendarRef = useRef(null);
  const [calendarEvents, setCalendarEvents] = useState(null);
  const [selectedDates, setSelectedDates] = useState({
    start: null,
    end: null,
  });

  const setDataForCalendar = () => {
    if (calendarRef.current) {
      const calendarApi = calendarRef.current.getApi();
      const startFormatted = moment(calendarApi.view.activeStart).format(
        "YYYY-MM-DD"
      );
      const endFormatted = moment(calendarApi.view.activeEnd).format(
        "YYYY-MM-DD"
      );

      setSelectedDates({ start: startFormatted, end: endFormatted });
      //   loadCalendarEvents(startFormatted, endFormatted);
    }
  };

  // const loadCalendarEvents = (start, end) => {
  //     try {
  //         // console.log(`Daty: ${start} - ${end}`);
  //         CalendarService.getBetweenDates(start, end)
  //         .then(response => {
  //             // console.log(response.data.data);
  //             setCalendarEvents(response.data.data);
  //         })
  //         .catch(error => {
  //             console.log(error);
  //         });
  //     } catch (error) {
  //         console.error('Error fetching data:', error);
  //     }
  // };

  useEffect(() => {
    setDataForCalendar();
  }, []);

  return (
    <>
      <PageHeader content={PageTitleConstants.Calendar} />
      <Card>
        <Card.Body className="pt-4-5">
          <Button
            variant="primary"
            onClick={() => {
              navigate(`/${RoutePathConstants.CalendarForm}`);
            }}
          >
            Dodaj dostępność
          </Button>
          <MonthlyCalendar
            calendarRef={calendarRef}
            calendarEvents={calendarEvents}
            onDateChange={setDataForCalendar}
          />
        </Card.Body>
      </Card>
    </>
  );
}

export default Calendar;
